import type { Doc } from "../../../_generated/dataModel";
import type { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

// Filtra movimientos por tipo sin perder el aislamiento de empresa/sucursal.
export const stockMovementTypeRule: FilterRule<Doc<"stock_movements">> = {
  priority: 2,
  build: async (ctx: FilterRuleCtx, args) => {
    const movementType = (
      args as Partial<Doc<"stock_movements">> & { movementType?: string }
    ).movementType;

    if (!movementType) return undefined;

    const rows = await ctx.db
      .query("stock_movements")
      .withIndex("by_company_and_movement_type", (q) =>
        q
          .eq("internalControl.companyId", ctx.userContext.companyId)
          .eq("movementType", movementType as Doc<"stock_movements">["movementType"]),
      )
      .collect();

    const branchId = ctx.userContext.branchId;
    return branchId
      ? rows.filter((row) => row.internalControl.branchId === branchId)
      : rows;
  },
};
